import { useEffect, useMemo, useState, useRef } from "react";
import { Stack, IconButton, ActionButton } from "@fluentui/react";
import DOMPurify from "dompurify";

import styles from "./Answer.module.css";

import { AskResponse, ConversationMessage, getCitationFilePath, sendFeedback } from "../../api";
import { parseAnswerToHtml } from "./AnswerParser";
import { AnswerIcon } from "./AnswerIcon";
import { LikeBtn } from "./LikeDislike";
import { DislikeForm } from "./DislikeForm";
import { ChatHelpRegular, Copy24Filled, Copy24Regular } from "@fluentui/react-icons";
import ReactMarkdown from "react-markdown";

import { Icon } from "@fluentui/react";

import "../../assets/fonts/ArialNova/ArialNova.ttf";

interface Props {
    // answer: string;
    message: ConversationMessage;
    isSelected?: boolean;
    onCitationClicked: (filePath: string) => void;
    // onThoughtProcessClicked: () => void;
    // onSupportingContentClicked: () => void;
    onFollowupQuestionClicked?: (question: string) => void;
    showFollowupQuestions?: boolean;
    onSendFeedback: (messageId: number, action: string) => void;
    onSendFeedbackMessage: (messageId: number, feedback: string, feedbackCategory: string | null) => void;
    // onFeedbackClicked: (fb: "up" | "down") => void;
    // messageID: number;
}

export const Answer = ({
    // answer,
    message,
    isSelected,
    onCitationClicked,
    onSendFeedback,
    onSendFeedbackMessage,
    onFollowupQuestionClicked,
    showFollowupQuestions
}: // messageID
Props) => {
    //const [index, setIndex] = useState(0);
    const parsedAnswer = useMemo(() => parseAnswerToHtml(message.bot_input, onCitationClicked), [message.bot_input]);
    let isThumbsUp = message.feedback == 1;
    let isThumbsDown = message.feedback == -1;
    let sanitizedAnswerHtml = DOMPurify.sanitize(parsedAnswer.answerHtml);
    const [feedbackForm, setFeedbackForm] = useState(false);
    let regex = /%%(.*?)%%/g;
    let regex_b = /\*\*(.*?)\*\*/g;
    //let regex_p = /_\/People First\/_/g;
    let regex_p = /_People First_/g;
    let regex_hl = /\((https?:\/\/[^\s]+)\)/g;
    let regex_a = /<a/gi;
    let regex_h = /^###(.+)\n/gm;
    let replacer = (match: any, group: any) => {
        // group is the part between %% and %%
        // Return the html format with the group as the href attribute
        return `<a rel="noopener noreferrer" target="_blank" href="${group}"> here</a>`;
    };
    let replacer_b = (match: any, group: any) => {
        // group is the part between %% and %%
        // Return the html format with the group as the href attribute
        return `<b>${group}</b>`;
    };
    let replacer_p = (match: any, group: any) => {
        // group is the part between %% and %%
        // Return the html format with the group as the href attribute
        return `<a rel="noopener noreferrer" target="_blank" href="https://www.lifeatford.com/generalsupport/">People First</a>`;
    };
    let replacer_a = (match: any, group: any) => {
        // group is the part between %% and %%
        // Return the html format with the group as the href attribute
        return `<a target="_blank"`;
    };
    let replacer_h = (match: any, group: any) => {
        // group is the part between %% and %%
        // Return the html format with the group as the href attribute
        return `<h3>${group}</h3>`;
    };
    sanitizedAnswerHtml = sanitizedAnswerHtml.replace(regex, replacer);
    sanitizedAnswerHtml = sanitizedAnswerHtml.replace(regex_h, replacer_h);
    sanitizedAnswerHtml = sanitizedAnswerHtml.replace(regex_b, replacer_b);
    sanitizedAnswerHtml = sanitizedAnswerHtml.replace(regex_p, replacer_p);
    sanitizedAnswerHtml = sanitizedAnswerHtml.replace(regex_a, replacer_a);
    sanitizedAnswerHtml = sanitizedAnswerHtml.replace(regex_hl, replacer);
    console.log(sanitizedAnswerHtml);

    const divref = useRef<HTMLDivElement>(null);

    let ignore = false;
    useEffect(() => {
        if (message.feedback == -1) {
            setFeedbackForm(true);
        }
        return () => {
            ignore = true;
        };
    }, []);

    const [copySelect, setCopySelect] = useState<boolean>(false);

    const [isHoverAnswer, setHoverAnswer] = useState(false);

    const handleMouseEnter = () => {
        setHoverAnswer(true);
    };

    const handleMouseLeave = () => {
        setHoverAnswer(false);
    };

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseOver = () => setIsHovered(true);
    const handleMouseOut = () => setIsHovered(false);

    return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <Stack horizontal horizontalAlign="space-between" style={{ marginRight: "5px", justifyContent: "end", marginTop: "20px", height: "32px" }}>
                {/*<AnswerIcon />*/}
                {isHoverAnswer && (
                    <Stack
                        horizontal
                        style={{
                            backgroundColor: "#f9f9f9",
                            borderRadius: "5px",
                            width: "118px",
                            boxShadow: "0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)",
                            paddingLeft: "3px",
                            paddingRight: "3px"
                        }}
                    >
                        <LikeBtn
                            isSelected={isThumbsUp}
                            direction="Like"
                            onSendFeedback={onSendFeedback}
                            onSendFeedbackMessage={onSendFeedbackMessage}
                            setAnswerFeedbackForm={setFeedbackForm}
                            messageId={message.messageId}
                        />
                        <LikeBtn
                            isSelected={isThumbsDown}
                            direction="Dislike"
                            onSendFeedback={onSendFeedback}
                            onSendFeedbackMessage={onSendFeedbackMessage}
                            setAnswerFeedbackForm={setFeedbackForm}
                            messageId={message.messageId}
                        />
                        <div onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} className={styles.copySelectHover}>
                            {!copySelect && (
                                <div title="Copy respose here">
                                    <Copy24Regular
                                        style={{ color: "#2047ef", marginTop: "3.5px", cursor: "pointer" }}
                                        onClick={() => {
                                            setCopySelect(true);
                                            if (divref.current) {
                                                navigator.clipboard.writeText(String(divref.current.textContent));
                                            }
                                            setTimeout(() => {
                                                setCopySelect(false);
                                            }, 1000);
                                        }}
                                    />
                                </div>
                            )}
                            {copySelect && (
                                <Stack horizontal>
                                    <div className={styles.popup}>
                                        <div>
                                            <Copy24Filled style={{ color: "#2047ef", marginTop: "3.5px" }} />
                                        </div>
                                        <span className={styles.popuptext} id={styles.myPopup}>
                                            Copied
                                        </span>
                                    </div>
                                </Stack>
                            )}
                        </div>
                    </Stack>
                )}
            </Stack>
            <Stack className={`${styles.answerContainer} ${isSelected && styles.selected}`} verticalAlign="space-between">
                <Stack.Item grow>
                    {/*<div className={styles.answerText} ref={divref}>
                        <ReactMarkdown>{sanitizedAnswerHtml}</ReactMarkdown>
                    </div>*/}
                    <div className={styles.answerText} dangerouslySetInnerHTML={{ __html: sanitizedAnswerHtml }} ref={divref}></div>
                </Stack.Item>

                <Stack.Item>
                    <div></div>
                </Stack.Item>
                {!!parsedAnswer.citations.length || feedbackForm ? (
                    <Stack.Item>
                        <hr style={{ marginRight: "-20px", marginLeft: "-20px", opacity: "30%" }} />
                    </Stack.Item>
                ) : (
                    <div></div>
                )}

                {!!parsedAnswer.citations.length && (
                    <Stack.Item>
                        <Stack horizontal wrap tokens={{ childrenGap: 5 }}>
                            <span className={styles.citationLearnMore}>
                                <b>Learn more:</b>
                            </span>
                            {parsedAnswer.citations.map((x, i) => {
                                const path = getCitationFilePath(x);

                                const x_title = x.split("_/_");
                                const x_cleaned = x_title[0];
                                return (
                                    <a key={i} className={styles.citation} title={x_cleaned} onClick={() => onCitationClicked(path)}>
                                        {`${++i}. ${x_cleaned}`}
                                    </a>
                                );
                            })}
                        </Stack>
                    </Stack.Item>
                )}
                <Stack.Item>
                    <div></div>
                </Stack.Item>
                {feedbackForm && (
                    <Stack.Item grow>
                        <div className={styles.feedbackFormBackground}>
                            <DislikeForm
                                onSendFeedback={onSendFeedback}
                                onSendFeedbackMessage={onSendFeedbackMessage}
                                setAnswerFeedbackForm={setFeedbackForm}
                                messageId={message.messageId}
                                feedbackForm={feedbackForm}
                            />
                        </div>
                    </Stack.Item>
                )}
            </Stack>
            <br />

            {!!parsedAnswer.followupQuestions.length && showFollowupQuestions && onFollowupQuestionClicked && (
                <Stack horizontal>
                    <span title="Follow-Up Questions" className={`${!!parsedAnswer.citations.length ? styles.followupQuestionsList : ""}`}>
                        <ChatHelpRegular style={{ color: "#174ae4", fontSize: "26", marginRight: "4px" }} />
                    </span>
                    <Stack horizontal wrap className={`${!!parsedAnswer.citations.length ? styles.followupQuestionsList : ""}`} tokens={{ childrenGap: 6 }}>
                        {parsedAnswer.followupQuestions.map((x, i) => {
                            return (
                                <a key={i} className={styles.followupQuestion} title={x} onClick={() => onFollowupQuestionClicked(x)}>
                                    {`${x}`}
                                </a>
                            );
                        })}
                    </Stack>
                </Stack>
            )}
        </div>
    );
};
